/* eslint-disable @typescript-eslint/ban-types */
let updater: Function | null = null;

export const useTableUpdate = () => ({
  get: () => updater,
  set: (x: Function) => { updater = x; },
  clear: () => { updater = null; },
});
